import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Star, Users, Globe, Quote } from "lucide-react";
import { IMAGES } from "../../data/site";
import { SectionEyebrow } from "../SectionEyebrow";

const PILLARS = [
    { id: "talentos", icon: <Sparkles size={18} />, t: "Desarrollo de talentos", d: "Programas que identifican y potencian habilidades reales." },
    { id: "global", icon: <Globe size={18} />, t: "Visión global", d: "Intercambios culturales que amplían horizontes." },
    { id: "tejido", icon: <Users size={18} />, t: "Tejido comunitario", d: "Encuentros que reconstruyen confianza colectiva." },
    { id: "lider", icon: <Star size={18} />, t: "Liderazgo social", d: "Formamos nuevos referentes para el territorio." },
];

export const MissionSplit = () => (
    <section className="py-20 lg:py-28 bg-brand-cream relative overflow-hidden">
        <div className="container-fe grid lg:grid-cols-2 gap-14 items-center">
            <div className="relative aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl">
                <img src={IMAGES.elderly_care} alt="Mujer adulta mayor sonriendo" className="w-full h-full object-cover" />
                <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur rounded-2xl p-5 ring-1 ring-black/5">
                    <div className="flex items-start gap-3">
                        <Quote size={28} className="text-brand-green shrink-0" />
                        <p className="text-sm text-brand-navy font-medium italic leading-relaxed">
                            "Aquí me siento parte de algo. Eso, a mi edad, vale más que el oro."
                        </p>
                    </div>
                    <div className="mt-3 text-xs text-muted-foreground">— Doña Rosario, 76 años</div>
                </div>
            </div>

            <div>
                <SectionEyebrow>Nuestra misión</SectionEyebrow>
                <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-brand-navy leading-tight">
                    No regalamos oportunidades.
                    <br />
                    <span className="text-brand-green">Las hacemos visibles.</span>
                </h2>
                <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
                    Creemos firmemente que cada niño, joven, adulto mayor o familia esconde
                    capacidades que merecen ser vistas. Nuestro trabajo es co-crear las
                    condiciones para que esas capacidades se desplieguen: a través del arte, la
                    educación, la cultura, los intercambios y los encuentros humanos.
                </p>
                <div className="mt-8 grid sm:grid-cols-2 gap-4">
                    {PILLARS.map((it) => (
                        <div key={it.id} className="card-flat">
                            <div className="h-10 w-10 rounded-full bg-brand-green-light text-brand-green flex items-center justify-center mb-3">
                                {it.icon}
                            </div>
                            <div className="font-display font-semibold text-brand-navy">{it.t}</div>
                            <div className="text-sm text-muted-foreground mt-1.5">{it.d}</div>
                        </div>
                    ))}
                </div>
                <Link to="/quienes-somos" className="btn-ghost-pill mt-8" data-testid="home-about-cta">
                    Conoce nuestra historia <ArrowRight size={16} />
                </Link>
            </div>
        </div>
    </section>
);
